import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

const WelcomePage = ({ deferredPrompt, isInstalled, showInstallButton }) => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (showInstallButton && !isInstalled) {
      // const dismissed = localStorage.getItem('pwaPromptDismissed');
      // if (!dismissed) {
        setShowBanner(true);
      // }
    } else {
      setShowBanner(false);
    }
  }, [showInstallButton, isInstalled]);

  const logger = (e) => {
    const role = e.currentTarget.querySelector("span").textContent.toLowerCase();

    if (role === 'admin') {
      navigate('/login');
    } else if (role === 'input result') {
      navigate('/login/teacher');
    } else if (role === 'check result') {
      navigate('/login/student');
    }
  };

  const handleInstall = async () => {
    try {
      await deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      
      setShowBanner(false);
      
      if (choiceResult.outcome === 'rejected') {
        localStorage.setItem('pwaPromptDismissed', 'true');
        setTimeout(() => {
          localStorage.removeItem('pwaPromptDismissed');
        }, 24 * 60 * 60 * 1000);
      }
    } catch (error) {
      console.error("Install error:", error);
    }
  };

  const handleCloseBanner = () => {
    setShowBanner(false);
    localStorage.setItem('pwaPromptDismissed', 'true');
    setTimeout(() => {
      localStorage.removeItem('pwaPromptDismissed');
    }, 24 * 60 * 60 * 1000);
  };

  return (
    <div className="welcome-page">
      {showBanner && (
        <div className="install-banner">
          <div className="banner-content">
            <span className="banner-title">
              📱 Install Nvolve Results App for better experience
            </span>
            <div className="banner-subtitle">
              Faster access • App-like experience • Works offline
            </div>
          </div>
          <div className="banner-actions">
            <button className="install-button" onClick={handleInstall}>
              Install
            </button>
            <button className="close-banner-button" onClick={handleCloseBanner}>
              ✕
            </button>
          </div>
        </div>
      )}

      <div className={`welcome-content ${showBanner ? 'with-banner' : ''}`}>
        <img src='/logo.png' alt="logo" className="welcome-logo" />
        <h1>Welcome to<br /> Nvolve Results</h1>
        <h2>How can I help you?</h2>

        <div className="role-buttons">
          <button onClick={logger}>
            <span>Check Result</span> 
            <ion-icon name="eye-outline"></ion-icon>
          </button>
          <button onClick={logger}>
            <span>Input Result</span> 
            <ion-icon name="document-outline"></ion-icon>
          </button>
          <button onClick={logger}>
            <span>Admin</span> 
            <ion-icon name="person-circle-outline"></ion-icon>
          </button>
        </div>

        <a href='https://wa.me/2349038031775' className="support-link">
          Contact Support
        </a>
      </div>
    </div>
  );
};

export default WelcomePage;